import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
	flex: 1;
	width: 100%;
	height: 100%;
`;

export const Content = styled.div`
	flex: 1;
  display: flex;
	// width: 100%;
	// height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
  // padding: 1rem 1.5rem 5rem;
	padding: 4rem 1.5rem 5rem 5.5rem;
	
	// 767px
  @media (max-width: 47.9375rem) {
		padding: 4rem 0.5rem 5rem;
  }
`;

export const Header = styled.div`
  display: flex;
	// flex-direction: column;
	justify-content: space-between;
  width: 100%;
	padding-bottom: 1rem;
  // margin-bottom: 20px;
	// border: 2px solid blue;

  h1 {
		font-size: 20px;
		font-weight: 500;
		text-overflow: ellipsis;
	}

	h2 {
		font-size: 20px;
		font-weight: 500;
		color: #607d8b;
		text-overflow: ellipsis;
	}

	button {
		display: flex;
		align-items: center;
    font-weight: 600;
    border-radius: 8px;
    padding: 6px 20px;
		// height: 60%;
    // margin: 5px 10px;

		background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

		:hover {
			background: #1565C0;
			border: 1px solid #1565C0;
		}

		:focus {
			background: #1565C0;
			border: 1px solid #1565C0;
		}

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

	// 767px
  @media (max-width: 47.9375rem) {
		button {
			font-size: 12px;
		}
	}
	// 557px
  @media (max-width: 34.8125rem) {
		button {
			padding: 6px 12px;
			svg {
				font-size: 18px;
			}
		}
  };
	// 479px
  @media (max-width: 29.9375rem) {
		margin-bottom: 10px;

		h1 {
			font-size: 18px;
		}

		h2 {
			font-size: 16px;
		}

		button {
			font-size: 12px;
			padding: 4px 10px;
		}
	}
`;

export const ContentData = styled.div`
	display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	padding: 10px 20px;
  overflow-y: auto;

	// 479px
  @media (max-width: 29.9375rem) {
		padding: 10px 10px;
	}
`;

export const FormView = styled(Form)`
  display: flex;
	flex-direction: column;
  width: 100%;
  margin-bottom: 5px;

	div.input {
		display: flex;
		flex-direction: column;
		width: 100%;

		p {
			font-size: 1rem;
			font-weight: 500;
			margin: 15px 0 3px;

			span {
				font-size: 0.8rem;
				color: #455a64;
			}
		}

		span {
			font-size: 0.8rem;
			font-weight: 500;
			color: #455a64;
			text-align: end;
			width: 100%;
			padding: 5px 10px 0 0;
		}
	}

	button {
		display: flex;
		align-items: center;
    font-weight: 600;
    border-radius: 7px;
    padding: 5px 10px;
    margin: 5px 10px 0;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		// flex-direction: column-reverse;

		/* div.form-right {
			width: 100%;
			justify-content: center;
			align-items: center;
		} */

		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end; // space-between;
  align-items: center;
  background-color: #fff;
  width: 100%;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;